import React from 'react'

export default function AddOutbound() {
  return (
    <div>AddOutbound</div>
  )
}
